export function fireSignupConversionEvent() {
  (window as any).dataLayer = (window as any).dataLayer || [];
  if ('dataLayer' in window && Array.isArray(window.dataLayer)) {
    window.dataLayer.push({
      event: 'sign_up',
    });
  }
}

export function fireLsPageView() {
  (window as any).dataLayer = (window as any).dataLayer || [];
  if ('dataLayer' in window && Array.isArray(window.dataLayer)) {
    window.dataLayer.push({
      event: 'ls_page_view',
    });
  }
}
